import React, { useState } from "react";
import { useEffect } from "react";
import ButtonIconH from "../../components/ButtonIconH";
import InputData from "../../components/InputData";
import DropdownFilter from "../../components/DropdownFilter";
import CheckBox from "../../components/CheckBox";

import { selectedOptic, userData } from "../../js/utils";
import { post } from "../utils/api";

import "../css/LoyaltyScreen.css";

const tokenSesion = userData ? userData.token : "";

export default function LoyaltyScreen(props) {
  const [idPerfil, setIdPerfil] = useState(props.idPerfil);
  const [nombre, setNombre] = useState("");
  const [opticas, setOpticas] = useState([]);
  const [contraValor, setContraValor] = useState("");
  const [ptosAltaTarjeta, setPtosAltaTarjeta] = useState("");
  const [topePtosPorCliente, setTopePtosPorCliente] = useState("");
  const [tipoAsignacion, setTipoAsignacion] = useState(""); // Importe / Familia
  // Importe
  const [porCadaXEurosCompra, setPorCadaXEurosCompra] = useState("");
  const [ptosGeneradosPorXEurosCompra, setPtosGeneradosPorXEurosCompra] =
    useState("");
  // Familia
  const [porCadaXEurosAudifonos, setPorCadaXEurosAudifonos] = useState("");
  const [ptosGeneradosXEurosAudifonos, setPtosGeneradosXEurosAudifonos] =
    useState("");
  const [porCadaXEurosCristales, setPorCadaXEurosCristales] = useState("");
  const [ptosGeneradosXEurosCristales, setPtosGeneradosXEurosCristales] =
    useState("");
  const [porCadaXEurosLentillas, setPorCadaXEurosLentillas] = useState("");
  const [ptosGeneradosXEurosLentillas, setPtosGeneradosXEurosLentillas] =
    useState("");
  const [porCadaXEurosLiquidos, setPorCadaXEurosLiquidos] = useState("");
  const [ptosGeneradosXEurosLiquidos, setPtosGeneradosXEurosLiquidos] =
    useState("");
  const [porCadaXEurosMonturas, setPorCadaXEurosMonturas] = useState("");
  const [ptosGeneradosXEurosMonturas, setPtosGeneradosXEurosMonturas] =
    useState("");
  const [porCadaXEurosVarios, setPorCadaXEurosVarios] = useState("");
  const [ptosGeneradosXEurosVarios, setPtosGeneradosXEurosVarios] =
    useState("");
  const [porCadaXEurosSol, setPorCadaXEurosSol] = useState("");
  const [ptosGeneradosXEurosSol, setPtosGeneradosXEurosSol] = useState("");
  const [avisosSMS, setAvisosSMS] = useState(false);

  const [listaOpticas, setListaOpticas] = useState([]);
  // const [listaOpticasSelected, setListaOpticasSelected] = useState([]);
  const [listaOpticasSelectedEstado, setListaOpticasSelectedEstado] = useState(
    [],
  );

  const [isLoading, setIsLoading] = useState(false);
  const [originalData, setOriginalData] = useState(null);

  useEffect(() => {
    if (!isLoading) {
      const timer = setTimeout(() => {
        const nombreInput = document.getElementById("nombre");
        // Asegúrate de hacer focus al input o elemento interactivo
        if (nombreInput) nombreInput.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  useEffect(() => {
    async function loadProfileData() {
      if (props.idPerfil === -1) {
        setIdPerfil(props.idPerfil);
        setNombre("");
        setOpticas([]);
        setContraValor("");
        setPtosAltaTarjeta("");
        setTopePtosPorCliente("");
        setTipoAsignacion("");
        setPorCadaXEurosCompra("");
        setPtosGeneradosPorXEurosCompra("");
        setPorCadaXEurosAudifonos("");
        setPtosGeneradosXEurosAudifonos("");
        setPorCadaXEurosCristales("");
        setPtosGeneradosXEurosCristales("");
        setPorCadaXEurosLentillas("");
        setPtosGeneradosXEurosLentillas("");
        setPorCadaXEurosLiquidos("");
        setPtosGeneradosXEurosLiquidos("");
        setPorCadaXEurosMonturas("");
        setPtosGeneradosXEurosMonturas("");
        setPorCadaXEurosVarios("");
        setPtosGeneradosXEurosVarios("");
        setPorCadaXEurosSol("");
        setPtosGeneradosXEurosSol("");
        setAvisosSMS(false);

        setOriginalData({
          nombre: "",
          opticas: [],
          contraValor: "",
          ptosAltaTarjeta: "",
          topePtosPorCliente: "",
          tipoAsignacion: "",
          porCadaXEurosCompra: "",
          ptosGeneradosPorXEurosCompra: "",
          porCadaXEurosAudifonos: "",
          ptosGeneradosXEurosAudifonos: "",
          porCadaXEurosCristales: "",
          ptosGeneradosXEurosCristales: "",
          porCadaXEurosLentillas: "",
          ptosGeneradosXEurosLentillas: "",
          porCadaXEurosLiquidos: "",
          ptosGeneradosXEurosLiquidos: "",
          porCadaXEurosMonturas: "",
          ptosGeneradosXEurosMonturas: "",
          porCadaXEurosVarios: "",
          ptosGeneradosXEurosVarios: "",
          porCadaXEurosSol: "",
          ptosGeneradosXEurosSol: "",
          avisosSMS: false,
        });

        return;
      }

      setIsLoading(true);
      setIdPerfil(props.idPerfil);

      let profileJSON = [];
      let queryJSON = { token: tokenSesion, id: props.idPerfil };

      profileJSON = await post(
        "Configuracion/ObtenerConfiguracionFidelizacion.php",
        queryJSON,
      );

      if (profileJSON) {
        const profileData = {
          nombre: profileJSON.nombre,
          opticas: profileJSON.opticas,
          contraValor: profileJSON.contraValor,
          ptosAltaTarjeta: profileJSON.ptosAltaTarjeta,
          topePtosPorCliente: profileJSON.topePtosPorCliente,
          tipoAsignacion: profileJSON.tipoAsignacion,
          porCadaXEurosCompra: profileJSON.porCadaXEurosCompra,
          ptosGeneradosPorXEurosCompra:
            profileJSON.ptosGeneradosPorXEurosCompra,
          porCadaXEurosAudifonos: profileJSON.porCadaXEurosAudifonos,
          ptosGeneradosXEurosAudifonos:
            profileJSON.ptosGeneradosXEurosAudifonos,
          porCadaXEurosCristales: profileJSON.porCadaXEurosCristales,
          ptosGeneradosXEurosCristales:
            profileJSON.ptosGeneradosXEurosCristales,
          porCadaXEurosLentillas: profileJSON.porCadaXEurosLentillas,
          ptosGeneradosXEurosLentillas:
            profileJSON.ptosGeneradosXEurosLentillas,
          porCadaXEurosLiquidos: profileJSON.porCadaXEurosLiquidos,
          ptosGeneradosXEurosLiquidos: profileJSON.ptosGeneradosXEurosLiquidos,
          porCadaXEurosMonturas: profileJSON.porCadaXEurosMonturas,
          ptosGeneradosXEurosMonturas: profileJSON.ptosGeneradosXEurosMonturas,
          porCadaXEurosVarios: profileJSON.porCadaXEurosVarios,
          ptosGeneradosXEurosVarios: profileJSON.ptosGeneradosXEurosVarios,
          porCadaXEurosSol: profileJSON.porCadaXEurosSol,
          ptosGeneradosXEurosSol: profileJSON.ptosGeneradosXEurosSol,
          avisosSMS: Boolean(profileJSON.avisosSMS),
        };

        setNombre(profileData.nombre);
        setOpticas(profileData.opticas);
        setListaOpticasSelectedEstado(profileData.opticas || []);
        setContraValor(profileData.contraValor);
        setPtosAltaTarjeta(profileData.ptosAltaTarjeta);
        setTopePtosPorCliente(profileData.topePtosPorCliente);
        setTipoAsignacion(profileData.tipoAsignacion);
        setPorCadaXEurosCompra(profileData.porCadaXEurosCompra);
        setPtosGeneradosPorXEurosCompra(
          profileData.ptosGeneradosPorXEurosCompra,
        );
        setPorCadaXEurosAudifonos(profileData.porCadaXEurosAudifonos);
        setPtosGeneradosXEurosAudifonos(
          profileData.ptosGeneradosXEurosAudifonos,
        );
        setPorCadaXEurosCristales(profileData.porCadaXEurosCristales);
        setPtosGeneradosXEurosCristales(
          profileData.ptosGeneradosXEurosCristales,
        );
        setPorCadaXEurosLentillas(profileData.porCadaXEurosLentillas);
        setPtosGeneradosXEurosLentillas(
          profileData.ptosGeneradosXEurosLentillas,
        );
        setPorCadaXEurosLiquidos(profileData.porCadaXEurosLiquidos);
        setPtosGeneradosXEurosLiquidos(profileData.ptosGeneradosXEurosLiquidos);
        setPorCadaXEurosMonturas(profileData.porCadaXEurosMonturas);
        setPtosGeneradosXEurosMonturas(profileData.ptosGeneradosXEurosMonturas);
        setPorCadaXEurosVarios(profileData.porCadaXEurosVarios);
        setPtosGeneradosXEurosVarios(profileData.ptosGeneradosXEurosVarios);
        setPorCadaXEurosSol(profileData.porCadaXEurosSol);
        setPtosGeneradosXEurosSol(profileData.ptosGeneradosXEurosSol);
        setAvisosSMS(profileData.avisosSMS);

        setOriginalData(profileData);
      } else {
        setNombre("");
        setOpticas([]);
        setContraValor("");
        setPtosAltaTarjeta("");
        setTopePtosPorCliente("");
        setTipoAsignacion("");
        setPorCadaXEurosCompra("");
        setPtosGeneradosPorXEurosCompra("");
        setPorCadaXEurosAudifonos("");
        setPtosGeneradosXEurosAudifonos("");
        setPorCadaXEurosCristales("");
        setPtosGeneradosXEurosCristales("");
        setPorCadaXEurosLentillas("");
        setPtosGeneradosXEurosLentillas("");
        setPorCadaXEurosLiquidos("");
        setPtosGeneradosXEurosLiquidos("");
        setPorCadaXEurosMonturas("");
        setPtosGeneradosXEurosMonturas("");
        setPorCadaXEurosVarios("");
        setPtosGeneradosXEurosVarios("");
        setPorCadaXEurosSol("");
        setPtosGeneradosXEurosSol("");
        setAvisosSMS(false);
      }

      setIsLoading(false);
    }
    loadProfileData();
  }, [props.idPerfil]);

  useEffect(() => {
    async function loadOpticsData() {
      let json_query = {
        token: tokenSesion,
        idEmpresa: "-1",
      };

      // console.log("JSON_QUERY_PERFILES_OPTICAS: ", json_query);

      let json_opticas = await post(
        "Configuracion/ListarOpticas.php",
        json_query,
      );

      // console.log("JSON_OPTICAS: ", json_opticas);

      if (Array.isArray(json_opticas)) {
        let opticsList = [];
        opticsList.push({ id: -1, text: "" });
        // let opticsListSelected = [];
        for (const el of json_opticas) {
          let optica = { id: el.idOptica, text: el.nombre_corto };
          /* let optica_selected = {
            id: el.idOptica,
            text: el.nombre_corto,
            active: listaOpticasSelectedEstado.includes(el.idOptica),
          }; */
          opticsList.push(optica);
          // opticsListSelected.push(optica_selected);
        }
        setListaOpticas(opticsList);
        //setListaOpticasSelected(opticsListSelected);
      }
    }
    loadOpticsData();
  }, [props.userId]);

  const minimunData = () => {
    let datosPerfil = !!(
      nombre?.trim() &&
      listaOpticasSelectedEstado?.length > 0 &&
      String(contraValor || "").trim() &&
      String(ptosAltaTarjeta || "").trim() &&
      String(topePtosPorCliente || "").trim()
    );

    let datosAsignacion = false;
    if (tipoAsignacion === "Importe") {
      datosAsignacion = !!(
        String(porCadaXEurosCompra || "").trim() &&
        String(ptosGeneradosPorXEurosCompra || "").trim()
      );
    } else if (tipoAsignacion === "Familia") {
      datosAsignacion = !!(
        String(porCadaXEurosAudifonos || "").trim() &&
        String(ptosGeneradosXEurosAudifonos || "").trim() &&
        String(porCadaXEurosCristales || "").trim() &&
        String(ptosGeneradosXEurosCristales || "").trim() &&
        String(porCadaXEurosLentillas || "").trim() &&
        String(ptosGeneradosXEurosLentillas || "").trim() &&
        String(porCadaXEurosLiquidos || "").trim() &&
        String(ptosGeneradosXEurosLiquidos || "").trim() &&
        String(porCadaXEurosMonturas || "").trim() &&
        String(ptosGeneradosXEurosMonturas || "").trim() &&
        String(porCadaXEurosVarios || "").trim() &&
        String(ptosGeneradosXEurosVarios || "").trim() &&
        String(porCadaXEurosSol || "").trim() &&
        String(ptosGeneradosXEurosSol || "").trim()
      );
    }

    return datosPerfil && datosAsignacion;
  };

  const hasChanges = () => {
    if (!originalData) return false;

    // Helper para comparar valores de forma segura:
    // Convierte a String y respeta el número 0 (usando ??). Evita todos los falsos positivos.
    const isDiff = (val1, val2) =>
      String(val1 ?? "").trim() !== String(val2 ?? "").trim();

    // 1. Evaluamos si el array de ópticas cambió (forzando ambos lados a String)
    const opticasOriginales = originalData.opticas || [];
    const opticasDiferentes =
      listaOpticasSelectedEstado.length !== opticasOriginales.length ||
      listaOpticasSelectedEstado.some(
        (id) => !opticasOriginales.map(String).includes(String(id)),
      );

    // 2. Comparamos todos los campos apuntando a las "keys" correctas usando el helper
    return (
      isDiff(nombre, originalData.nombre) ||
      isDiff(contraValor, originalData.contraValor) ||
      isDiff(ptosAltaTarjeta, originalData.ptosAltaTarjeta) ||
      isDiff(topePtosPorCliente, originalData.topePtosPorCliente) ||
      isDiff(tipoAsignacion, originalData.tipoAsignacion) ||
      isDiff(porCadaXEurosCompra, originalData.porCadaXEurosCompra) ||
      isDiff(
        ptosGeneradosPorXEurosCompra,
        originalData.ptosGeneradosPorXEurosCompra,
      ) ||
      isDiff(porCadaXEurosAudifonos, originalData.porCadaXEurosAudifonos) ||
      isDiff(
        ptosGeneradosXEurosAudifonos,
        originalData.ptosGeneradosXEurosAudifonos,
      ) ||
      isDiff(porCadaXEurosCristales, originalData.porCadaXEurosCristales) ||
      isDiff(
        ptosGeneradosXEurosCristales,
        originalData.ptosGeneradosXEurosCristales,
      ) ||
      isDiff(porCadaXEurosLentillas, originalData.porCadaXEurosLentillas) ||
      isDiff(
        ptosGeneradosXEurosLentillas,
        originalData.ptosGeneradosXEurosLentillas,
      ) ||
      isDiff(porCadaXEurosLiquidos, originalData.porCadaXEurosLiquidos) ||
      isDiff(
        ptosGeneradosXEurosLiquidos,
        originalData.ptosGeneradosXEurosLiquidos,
      ) ||
      isDiff(porCadaXEurosMonturas, originalData.porCadaXEurosMonturas) ||
      isDiff(
        ptosGeneradosXEurosMonturas,
        originalData.ptosGeneradosXEurosMonturas,
      ) ||
      isDiff(porCadaXEurosVarios, originalData.porCadaXEurosVarios) ||
      isDiff(
        ptosGeneradosXEurosVarios,
        originalData.ptosGeneradosXEurosVarios,
      ) ||
      isDiff(porCadaXEurosSol, originalData.porCadaXEurosSol) ||
      isDiff(ptosGeneradosXEurosSol, originalData.ptosGeneradosXEurosSol) ||
      avisosSMS !== originalData.avisosSMS ||
      opticasDiferentes
    );
  };

  const handleClose = () => {
    if (hasChanges()) {
      props.createPopupQuestion(
        `Hay cambios sin guardar. ¿Seguro que quieres salir sin guardar?`,
        async () => {
          discardChanges();
          props.removePopupQuestion();
        },
        props.removePopupQuestion,
        "Sí",
        "No",
      );
    } else {
      props.closeFunction();
    }
  };

  const discardChanges = () => {
    if (originalData) {
      setNombre(originalData.nombre);
      setOpticas(originalData.opticas);
      setContraValor(originalData.contraValor);
      setPtosAltaTarjeta(originalData.ptosAltaTarjeta);
      setTopePtosPorCliente(originalData.topePtosPorCliente);
      setTipoAsignacion(originalData.tipoAsignacion);
      setPorCadaXEurosCompra(originalData.porCadaXEurosCompra);
      setPtosGeneradosPorXEurosCompra(
        originalData.ptosGeneradosPorXEurosCompra,
      );
      setPorCadaXEurosAudifonos(originalData.porCadaXEurosAudifonos);
      setPtosGeneradosXEurosAudifonos(
        originalData.ptosGeneradosXEurosAudifonos,
      );
      setPorCadaXEurosCristales(originalData.porCadaXEurosCristales);
      setPtosGeneradosXEurosCristales(
        originalData.ptosGeneradosXEurosCristales,
      );
      setPorCadaXEurosLentillas(originalData.porCadaXEurosLentillas);
      setPtosGeneradosXEurosLentillas(
        originalData.ptosGeneradosXEurosLentillas,
      );
      setPorCadaXEurosLiquidos(originalData.porCadaXEurosLiquidos);
      setPtosGeneradosXEurosLiquidos(originalData.ptosGeneradosXEurosLiquidos);
      setPorCadaXEurosMonturas(originalData.porCadaXEurosMonturas);
      setPtosGeneradosXEurosMonturas(originalData.ptosGeneradosXEurosMonturas);
      setPorCadaXEurosVarios(originalData.porCadaXEurosVarios);
      setPtosGeneradosXEurosVarios(originalData.ptosGeneradosXEurosVarios);
      setPorCadaXEurosSol(originalData.porCadaXEurosSol);
      setPtosGeneradosXEurosSol(originalData.ptosGeneradosXEurosSol);
      setAvisosSMS(Boolean(originalData.avisosSMS));
    } else {
      setNombre("");
      setOpticas([]);
      setContraValor("");
      setPtosAltaTarjeta("");
      setTopePtosPorCliente("");
      setTipoAsignacion("");
      setPorCadaXEurosCompra("");
      setPtosGeneradosPorXEurosCompra("");
      setPorCadaXEurosAudifonos("");
      setPtosGeneradosXEurosAudifonos("");
      setPorCadaXEurosCristales("");
      setPtosGeneradosXEurosCristales("");
      setPorCadaXEurosLentillas("");
      setPtosGeneradosXEurosLentillas("");
      setPorCadaXEurosLiquidos("");
      setPtosGeneradosXEurosLiquidos("");
      setPorCadaXEurosMonturas("");
      setPtosGeneradosXEurosMonturas("");
      setPorCadaXEurosVarios("");
      setPtosGeneradosXEurosVarios("");
      setPorCadaXEurosSol("");
      setPtosGeneradosXEurosSol("");
      setAvisosSMS(false);
    }

    props.closeFunction();
  };

  const saveProfileData = async () => {
    if (!minimunData()) {
      props.createPopupQuestion(
        `Los campos con (*) son obligatorios.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    } else {
      let json_query = {
        token: tokenSesion,
        id: idPerfil,
        idOptica: selectedOptic.id,
        nombre: nombre,
        opticas: listaOpticasSelectedEstado,
        contraValor: String(contraValor).replace(",", "."),
        ptosAltaTarjeta: ptosAltaTarjeta,
        topePtosPorCliente: topePtosPorCliente,
        tipoAsignacion: tipoAsignacion,
        porCadaXEurosCompra: String(porCadaXEurosCompra).replace(",", "."),
        ptosGeneradosPorXEurosCompra: String(
          ptosGeneradosPorXEurosCompra,
        ).replace(",", "."),
        porCadaXEurosAudifonos: String(porCadaXEurosAudifonos).replace(
          ",",
          ".",
        ),
        ptosGeneradosXEurosAudifonos: String(
          ptosGeneradosXEurosAudifonos,
        ).replace(",", "."),
        porCadaXEurosCristales: String(porCadaXEurosCristales).replace(
          ",",
          ".",
        ),
        ptosGeneradosXEurosCristales: String(
          ptosGeneradosXEurosCristales,
        ).replace(",", "."),
        porCadaXEurosLentillas: String(porCadaXEurosLentillas).replace(
          ",",
          ".",
        ),
        ptosGeneradosXEurosLentillas: String(
          ptosGeneradosXEurosLentillas,
        ).replace(",", "."),
        porCadaXEurosLiquidos: String(porCadaXEurosLiquidos).replace(",", "."),
        ptosGeneradosXEurosLiquidos: String(
          ptosGeneradosXEurosLiquidos,
        ).replace(",", "."),
        porCadaXEurosMonturas: String(porCadaXEurosMonturas).replace(",", "."),
        ptosGeneradosXEurosMonturas: String(
          ptosGeneradosXEurosMonturas,
        ).replace(",", "."),
        porCadaXEurosVarios: String(porCadaXEurosVarios).replace(",", "."),
        ptosGeneradosXEurosVarios: String(ptosGeneradosXEurosVarios).replace(
          ",",
          ".",
        ),
        porCadaXEurosSol: String(porCadaXEurosSol).replace(",", "."),
        ptosGeneradosXEurosSol: String(ptosGeneradosXEurosSol).replace(
          ",",
          ".",
        ),
        avisosSMS: avisosSMS,
      };

      let newIdPerfil = -1;
      let error = "";

      console.log("JSON_QUERY_PERFIL: ", json_query);

      await post(
        "Configuracion/GuardarConfiguracionFidelizacion.php",
        json_query,
      ).then((data) => {
        newIdPerfil = data.id;
        error = data.error;
      });

      if (newIdPerfil === -1) {
        // console.log(error);
        props.createPopupQuestion(
          `Ocurrió un error al grabar los datos.`,
          props.removePopupQuestion,
          null,
          "Entendido",
        );
        return false;
      } else {
        // Avisamos al padre que se guardó correctamente
        if (props.onSave) {
          props.onSave(newIdPerfil);
        }
        return true;
      }
    }
  };

  const deleteProfileData = async () => {
    let json_query = { token: tokenSesion, id: idPerfil };
    let deleteError = "";

    await post(
      "Configuracion/EliminarConfiguracionFidelizacion.php",
      json_query,
    ).then((data) => {
      deleteError = data.error;
    });

    //console.log("ERROR: ", deleteError);

    if (deleteError !== "") {
      props.createPopupQuestion(
        deleteError,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
      return false;
    } else {
      if (props.onDelete) {
        props.onDelete();
      }
      return true;
    }
  };

  const handleTipoAsignacionChanged = (tipo) => {
    if (tipo === "Importe") {
      setPorCadaXEurosAudifonos("");
      setPtosGeneradosXEurosAudifonos("");
      setPorCadaXEurosCristales("");
      setPtosGeneradosXEurosCristales("");
      setPorCadaXEurosLentillas("");
      setPtosGeneradosXEurosLentillas("");
      setPorCadaXEurosLiquidos("");
      setPtosGeneradosXEurosLiquidos("");
      setPorCadaXEurosMonturas("");
      setPtosGeneradosXEurosLiquidos("");
      setPorCadaXEurosMonturas("");
      setPtosGeneradosXEurosMonturas("");
      setPorCadaXEurosVarios("");
      setPtosGeneradosXEurosVarios("");
      setPorCadaXEurosSol("");
      setPtosGeneradosXEurosSol("");
    } else if (tipo === "Familia") {
      setPorCadaXEurosCompra("");
      setPtosGeneradosPorXEurosCompra("");
    }
  };

  const opcionesCalculadasFiltro = listaOpticas
    .filter((opt) => opt.id !== -1)
    .map((opt) => ({
      id: opt.id, // Mantenemos el tipo original (probablemente Number)
      text: opt.text,
      // Comparamos forzando a String temporalmente para evitar fallos
      active: listaOpticasSelectedEstado.some(
        (selecId) => String(selecId) === String(opt.id),
      ),
    }));

  return (
    <div className="loyalty-popup-container">
      <div className="loyalty-popup-screen">
        <div className="loyalty-popup-screen-header">
          <button className="popup-action-icon close-icon">
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt="Icon"
              onClick={() => {
                handleClose();
              }}
            ></img>
          </button>
          <span className="popup-screen-header-title">
            Perfiles de fidelización
          </span>
        </div>
        <div className="loyalty-section-content">
          <div className="loyalty-container-block">
            <div className="user-data-field-row">
              <span className="user-h3-black">Datos del perfil</span>
            </div>
            <div className="loyalty-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="loyalty-section-block">
              <div className="loyalty-data-block">
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Nombre (*)</span>
                    <InputData
                      tabIndex={1}
                      id="dni"
                      type="text"
                      size={6}
                      input={nombre}
                      onChange={(e) => {
                        setNombre(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Ópticas (*)</span>
                    <DropdownFilter
                      size={0}
                      tabIndex={2}
                      disabled={false}
                      optionList={opcionesCalculadasFiltro}
                      op={"ÓPTICAS"}
                      selectedOptions={listaOpticasSelectedEstado}
                      onChange={(e) => {
                        // 1. Comprobamos si el ID ya está seleccionado (comparando como textos)
                        const existe = listaOpticasSelectedEstado.some(
                          (id) => String(id) === String(e.id),
                        );

                        // 2. Filtramos o añadimos conservando el tipo de dato original de e.id
                        const updatedOpticasSelectedEstado = existe
                          ? listaOpticasSelectedEstado.filter(
                              (id) => String(id) !== String(e.id),
                            )
                          : [...listaOpticasSelectedEstado, e.id];

                        setListaOpticasSelectedEstado(
                          updatedOpticasSelectedEstado,
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <span className="loyalty-label">Enviar avisos por SMS</span>
                  <CheckBox
                    id="avisoSMS"
                    tabIndex={3}
                    active={avisosSMS}
                    onClick={() => {
                      setAvisosSMS(!avisosSMS);
                    }}
                  />
                </div>
              </div>
              <div className="loyalty-data-block">
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Valor de un punto (*)</span>
                    <InputData
                      tabIndex={4}
                      id="dni"
                      type="text"
                      size={6}
                      input={contraValor}
                      onChange={(e) => {
                        setContraValor(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Puntos de bienvenida (*)
                    </span>
                    <InputData
                      tabIndex={5}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosAltaTarjeta}
                      onChange={(e) => {
                        setPtosAltaTarjeta(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Número máximo de puntos (*)
                    </span>
                    <InputData
                      tabIndex={6}
                      id="dni"
                      type="text"
                      size={6}
                      input={topePtosPorCliente}
                      onChange={(e) => {
                        setTopePtosPorCliente(e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loyalty-container-block">
            <div className="loyalty-data-field-row">
              <CheckBox
                id="opcionA"
                tabIndex={7}
                active={tipoAsignacion === "Importe"}
                onClick={() => {
                  setTipoAsignacion("Importe");
                  handleTipoAsignacionChanged("Importe");
                }}
              />
              <span className="user-h3-black">
                Opción A - Generar puntos según el importe de la venta
              </span>
            </div>
            <div className="loyalty-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="loyalty-section-block">
              <div className="loyalty-data-block">
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Por cada X euros (*)</span>
                    <InputData
                      tabIndex={8}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosCompra}
                      onChange={(e) => {
                        setPorCadaXEurosCompra(e);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="loyalty-data-block">
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={9}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosPorXEurosCompra}
                      onChange={(e) => {
                        setPtosGeneradosPorXEurosCompra(e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="loyalty-container-block">
            <div className="loyalty-data-field-row">
              <CheckBox
                id="opcionB"
                tabIndex={10}
                active={tipoAsignacion === "Familia"}
                onClick={() => {
                  setTipoAsignacion("Familia");
                  handleTipoAsignacionChanged("Familia");
                }}
              />
              <span className="user-h3-black">
                Opción B - Generar puntos según el importe de la venta y según
                la familia de productos
              </span>
            </div>
            <div className="loyalty-data-field-row">
              <div className="breaker-gr mb-8" />
            </div>
            <div className="loyalty-section-block">
              <div className="loyalty-data-block">
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros Audifonos (*)
                    </span>
                    <InputData
                      tabIndex={11}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosAudifonos}
                      onChange={(e) => {
                        setPorCadaXEurosAudifonos(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros Lentes (*)
                    </span>
                    <InputData
                      tabIndex={13}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosCristales}
                      onChange={(e) => {
                        setPorCadaXEurosCristales(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros LC (*)
                    </span>
                    <InputData
                      tabIndex={15}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosLentillas}
                      onChange={(e) => {
                        setPorCadaXEurosLentillas(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros Líquidos (*)
                    </span>
                    <InputData
                      tabIndex={17}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosLiquidos}
                      onChange={(e) => {
                        setPorCadaXEurosLiquidos(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros Vista (*)
                    </span>
                    <InputData
                      tabIndex={19}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosMonturas}
                      onChange={(e) => {
                        setPorCadaXEurosMonturas(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros Varios (*)
                    </span>
                    <InputData
                      tabIndex={21}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosVarios}
                      onChange={(e) => {
                        setPorCadaXEurosVarios(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">
                      Por cada X euros Sol (*)
                    </span>
                    <InputData
                      tabIndex={23}
                      id="dni"
                      type="text"
                      size={6}
                      input={porCadaXEurosSol}
                      onChange={(e) => {
                        setPorCadaXEurosSol(e);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="loyalty-data-block">
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={12}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosAudifonos}
                      onChange={(e) => {
                        setPtosGeneradosXEurosAudifonos(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={14}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosCristales}
                      onChange={(e) => {
                        setPtosGeneradosXEurosCristales(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={16}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosLentillas}
                      onChange={(e) => {
                        setPtosGeneradosXEurosLentillas(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={18}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosLiquidos}
                      onChange={(e) => {
                        setPtosGeneradosXEurosLiquidos(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={20}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosMonturas}
                      onChange={(e) => {
                        setPtosGeneradosXEurosMonturas(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={22}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosVarios}
                      onChange={(e) => {
                        setPtosGeneradosXEurosVarios(e);
                      }}
                    />
                  </div>
                </div>
                <div className="loyalty-data-field-row">
                  <div className="loyalty-data-field d-loyalty-large">
                    <span className="loyalty-label">Generar X puntos (*)</span>
                    <InputData
                      tabIndex={24}
                      id="dni"
                      type="text"
                      size={6}
                      input={ptosGeneradosXEurosSol}
                      onChange={(e) => {
                        setPtosGeneradosXEurosSol(e);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="popup-row-buttons-container">
          <div className="popup-row-buttons profile-menu">
            <ButtonIconH
              text="Cancelar"
              onClick={() => {
                handleClose();
              }}
            />
            <ButtonIconH
              text="Guardar"
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea guardar los cambios realizados en este perfil?`,
                  async () => {
                    const guardadoExitoso = await saveProfileData();

                    if (guardadoExitoso) {
                      props.removePopupQuestion();
                      props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
            <ButtonIconH
              text="Eliminar"
              disabled={idPerfil === -1}
              onClick={() => {
                props.createPopupQuestion(
                  `¿Desea eliminar el perfil actual?`,
                  async () => {
                    const borradoExitoso = await deleteProfileData();

                    if (borradoExitoso) {
                      props.removePopupQuestion();
                      props.closeFunction();
                    }
                  },
                  props.removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
